/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Index_Banner_ContentInputs */

const en_admin_resources_index_banner_content = /** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish resources to allow bookings by non-members`)
};

const de_admin_resources_index_banner_content = /** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen veröffentlichen, um Buchungen durch Nicht-Mitglieder zu ermöglichen`)
};

const es_admin_resources_index_banner_content = /** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica tus recursos para que los no-miembros puedan reservarlos`)
};

const fr_admin_resources_index_banner_content = /** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publiez des ressources pour permettre les réservations par des non-membres`)
};

const nl_admin_resources_index_banner_content = /** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publiceer voorzieningen om reserveringen door niet-leden toe te staan`)
};

/** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */
const it_admin_resources_index_banner_content = en_admin_resources_index_banner_content;

/** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */
const pt_br2_admin_resources_index_banner_content = en_admin_resources_index_banner_content;

/** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */
const pl_admin_resources_index_banner_content = en_admin_resources_index_banner_content;

/** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */
const hu_admin_resources_index_banner_content = en_admin_resources_index_banner_content;

/** @type {(inputs: Admin_Resources_Index_Banner_ContentInputs) => LocalizedString} */
const ro_admin_resources_index_banner_content = en_admin_resources_index_banner_content;

/**
* | output |
* | --- |
* | "Publish resources to allow bookings by non-members" |
*
* @param {Admin_Resources_Index_Banner_ContentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_index_banner_content = /** @type {((inputs?: Admin_Resources_Index_Banner_ContentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Index_Banner_ContentInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_index_banner_content(inputs)
	if (locale === "de") return de_admin_resources_index_banner_content(inputs)
	if (locale === "es") return es_admin_resources_index_banner_content(inputs)
	if (locale === "fr") return fr_admin_resources_index_banner_content(inputs)
	if (locale === "nl") return nl_admin_resources_index_banner_content(inputs)
	if (locale === "it") return it_admin_resources_index_banner_content(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_index_banner_content(inputs)
	if (locale === "pl") return pl_admin_resources_index_banner_content(inputs)
	if (locale === "hu") return hu_admin_resources_index_banner_content(inputs)
	return ro_admin_resources_index_banner_content(inputs)
});
export { admin_resources_index_banner_content as "admin.resources.index_banner_content" }